
import React from 'react';
import { Cloud, DollarSign, ChevronRight } from 'lucide-react';
import logo from '/lovable-uploads/40a4ee59-7714-4091-a6f7-e5ba5819fe5f.png';
import { saveAdslTransactionToSupabase } from '@/lib/supabase';
import PageLayout from '@/components/PageLayout';
import AdBanner from '@/components/AdBanner';
import { useTranslation } from 'react-i18next';
import { dialUssd } from '@/utils/ussd-utils';

const Adsl = () => {
  const { t } = useTranslation();
  
  const handleCheckBalance = async () => {
    // Record the transaction
    const transaction = {
      transactionType: 'check',
      date: new Date().toISOString()
    };
    
    // Save to Supabase
    await saveAdslTransactionToSupabase(transaction);
    
    // Open the phone dialer with *134# code
    dialUssd('*134#');
    
    console.log(`${t('adsl.checkBalance')} - ${t('adsl.openingCode')} *134#`);
  };
  
  const handlePayAdsl = async () => {
    // Record the transaction
    const transaction = {
      transactionType: 'payment',
      date: new Date().toISOString()
    };
    
    // Save to Supabase
    await saveAdslTransactionToSupabase(transaction);
    
    // Open the phone dialer with *133# code
    dialUssd('*133#');
    
    console.log(`${t('adsl.pay')} - ${t('adsl.openingCode')} *133#`);
  };

  return (
    <PageLayout 
      title={t('adsl.title')} 
      logo={logo} 
      showBackButton 
      colorScheme="bg-gradient-to-r from-blue-500 via-cyan-500 to-teal-500"
    >
      {/* Ad Banner for adsl page */}
      <AdBanner pageSlug="adsl" />
      
      <div className="space-y-4">
        {/* Check ADSL Balance Option */}
        <div 
          className="flex items-center justify-between p-4 sm:p-6 bg-white rounded-xl shadow-md border border-blue-100 cursor-pointer hover:shadow-lg transition-all"
          onClick={handleCheckBalance}
          style={{ background: 'linear-gradient(to right, #ffffff, #e0f2fe)' }}
        >
          <div className="flex items-center">
            <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-gradient-to-br from-blue-100 to-cyan-200 flex items-center justify-center mr-3 sm:mr-5">
              <Cloud className="text-blue-600" size={24} />
            </div>
            <span className="text-base sm:text-lg font-medium text-gray-800">{t('adsl.checkBalance')}</span>
          </div>
          <ChevronRight className="text-blue-400" size={22} />
        </div>
        
        {/* Pay ADSL Option */}
        <div 
          className="flex items-center justify-between p-4 sm:p-6 bg-white rounded-xl shadow-md border border-red-100 cursor-pointer hover:shadow-lg transition-all"
          onClick={handlePayAdsl}
          style={{ background: 'linear-gradient(to right, #ffffff, #ffedd5)' }}
        >
          <div className="flex items-center">
            <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-gradient-to-br from-red-100 to-orange-200 flex items-center justify-center mr-3 sm:mr-5">
              <DollarSign className="text-red-600" size={24} />
            </div>
            <span className="text-base sm:text-lg font-medium text-gray-800">{t('adsl.pay')}</span>
          </div>
          <ChevronRight className="text-red-400" size={22} />
        </div>
      </div>
    </PageLayout>
  );
};

export default Adsl;
